import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { HISTORY_STATUSES } from '~/features/cost-estimate/utils/cost-approvals-search';

const CostApprovalsPage = lazy(
  () => import('~/features/catalog-enrichment/pages/cost-approvals-page'),
);

/** History status filter and 1-based page in the URL; a bad value opens the default view. */
const costApprovalsSearchSchema = z.object({
  /** `waiting` (open gates) or `history` (decided, narrowed by `status`); unset picks for you. */
  view: z.enum(['waiting', 'history']).optional().catch(undefined),
  status: z.enum(HISTORY_STATUSES).optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
});

/** Cost decisions on catalog-service (§95): what waits for a decision, and every decision made. */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-enrichment/cost-approvals')({
  validateSearch: costApprovalsSearchSchema,
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <CostApprovalsPage />
    </Suspense>
  ),
});
